export const omitData = (data: any) => omit(data, ["data"]);

export const wrap = <T>(items?: T | T[]): T[] => {
  if (!items) return [];
  return Array.isArray(items) ? items : [items];
};

export const isString = (value: any): value is string => {
  return typeof value === "string";
};

export function pick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  const result = {} as Pick<T, K>;
  for (const key of keys) {
    if (key in (obj as any)) {
      result[key] = obj[key];
    }
  }
  return result;
}

export function omit<T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
  const result = { ...obj } as T;
  for (const key of keys) {
    delete result[key];
  }
  return result;
}

export const omitNil = <T extends Record<string, any>>(obj: T): T => {
  const result = {} as T;

  for (const key in obj) {
    if (obj[key] != null) {
      result[key] = obj[key];
    }
  }

  return result;
};
